import { render, staticRenderFns } from "./groupTableLayer.vue?vue&type=template&id=8d52a992&scoped=true&"
import script from "./groupTableLayer.vue?vue&type=script&lang=js&"
export * from "./groupTableLayer.vue?vue&type=script&lang=js&"
import style0 from "./groupTableLayer.vue?vue&type=style&index=0&id=8d52a992&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d52a992",
  null
  
)

export default component.exports